<template>
    <div id="titleAtom" class="position-relative">   
        <input
            v-model="content"
            @input="$emit('changeTitle', content)"
            placeholder="Escreva o título aqui..."
            class="form-control title-input"
            type="text"
            :style="extraStyle"
        />

        <div class="button-child-frame--container">
			<button 
                v-b-tooltip.hover
				title="Configuração do título"
				v-if="showSettings"
				class="button-child-frame button-setting-title mb-1"
				@click="() => $emit('openSettingsFrameChild')"
			>
				<i class="fal fa-cog fa-md"></i>
			</button>

			<button 
                v-b-tooltip.hover
				title="Excluir texto"
				v-if="showSettings"
				class="button-child-frame button-delete-title"
				@click="() => $emit('deleteFrameChild')"
			>
				<i class="fal fa-trash-alt fa-md"></i>
			</button>
		</div>
    </div>
</template>

<script>
export default {
    name: "titleAtom",
    props: {
        title: {
            type: String,
            default: '',
        },
        hasImageBackground: {
            type: Boolean,
            default: false,
        },
        extra: {
            type: Object,
            default: {},
        },
        defaultColors: {
            type: Object,
            default: {},
        },
        showSettings: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            content: '',
            valueExtra: {},
        }
    },
    computed: {
        extraStyle() {
            let style = {};

            style = {
                ...this.valueExtra.style,
            }

            if (!style.color && (this.defaultColors.colorDefault || this.defaultColors.colorInverted)) {
                style.color = this.hasImageBackground ? this.defaultColors.colorInverted : this.defaultColors.colorDefault;
            }

            if (this.valueExtra.style_font_size_lock) {
                style.fontSize = '';
            }

            if (this.valueExtra.style_font_weight_lock) {
                style.fontWeight = '';
            }

            if (this.valueExtra.style_text_align_lock) {
                style.textAlign = '';
            }

            return style;
        }
    },
    watch: {
        extra: {
            handler() {
                this.valueExtra = this.extra;
            },
            deep: true,
        },
    },
    created() {
        this.content = this.title;

        if (this.extra) {
            this.valueExtra = this.extra;
        }
    },
}
</script>

<style>
#titleAtom .title-input {
    background: transparent;
    font-size: 1.5rem;
}

#titleAtom .button-child-frame--container {
    position: absolute;
    top: -10px;
    bottom: 0;
    right: -12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

#titleAtom .button-child-frame {
    border: 1px solid #dddddd;
    background-color: #fff;
    color: #222;
    cursor: pointer;
    min-width: 26px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

#titleAtom .button-child-frame:hover {
    background-color: var(--main-color);
    border: 1px solid var(--main-color);
    color: #fff;
}

#titleAtom .button-child-frame {
    opacity: 0;
    transition: all 300ms ease-in-out;
}

#titleAtom:hover .button-child-frame {
    opacity: 1;
    transition: all 300ms ease-in-out;
}
</style>


// WEBPACK FOOTER //
// src/components/blocks/TitleBlock.vue